import React, { useEffect, useState } from "react";
import Heroslider from "../../Componinets/Heroslider";
import "./Home.css";
import Slideproduct from "../../Componinets/Slideproduct/Slideproduct";
import SlideProductLoading from "../../Componinets/Slideproduct/SlideProductLoading";
import PageTransion from "../../Componinets/PageTransion";

let categories = [
  "smartphones",
  "mobile-accessories",
  "laptops",
  "tablets",
  "sunglasses",
  "sports-accessories",
];

function Home() {
  let [products, setproducts] = useState({});
  let [Loading, setLoading] = useState(true);

  useEffect(() => {
    let fetchProducts = async () => {
      try {
        let results = await Promise.all(
          categories.map(async (category) => {
            let res = await fetch(
              `https://dummyjson.com/products/category/${category}`
            );
            let data = await res.json();
            return { [category]: data.products };
          })
        );

        let productsData = Object.assign({}, ...results);
        setproducts(productsData);
      } catch (error) {
        console.error("error Fetching", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  return (
    <PageTransion>
      <div>
        <Heroslider />

        {Loading
          ? categories.map((category) => <SlideProductLoading key={category} />)
          : categories.map((category) => (
              <Slideproduct
                key={category}
                data={products[category]}
                title={category.replace("-", " ")}
              />
            ))}
      </div>
    </PageTransion>
  );
}

export default Home;
